var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No-show",
    clipPath: "url(#clip0_1251_7142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alert_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.86612 2.09766L14.6221 12.067C14.7099 12.219 14.7561 12.3914 14.7561 12.567C14.7561 12.7425 14.7099 12.915 14.6221 13.067C14.5344 13.219 14.4081 13.3452 14.2561 13.433C14.1041 13.5208 13.9317 13.567 13.7561 13.567H2.24412C2.06858 13.567 1.89614 13.5208 1.74412 13.433C1.59211 13.3452 1.46587 13.219 1.37811 13.067C1.29034 12.915 1.24414 12.7425 1.24414 12.567C1.24414 12.3914 1.29035 12.219 1.37812 12.067L7.13412 2.09766C7.51878 1.43099 8.48078 1.43099 8.86612 2.09766ZM8.00012 9.99899C7.8233 9.99899 7.65374 10.0692 7.52871 10.1943C7.40369 10.3193 7.33345 10.4888 7.33345 10.6657C7.33345 10.8425 7.40369 11.012 7.52871 11.1371C7.65374 11.2621 7.8233 11.3323 8.00012 11.3323C8.17693 11.3323 8.3465 11.2621 8.47152 11.1371C8.59654 11.012 8.66678 10.8425 8.66678 10.6657C8.66678 10.4888 8.59654 10.3193 8.47152 10.1943C8.3465 10.0692 8.17693 9.99899 8.00012 9.99899ZM8.00012 5.33232C7.83683 5.33234 7.67922 5.39229 7.5572 5.5008C7.43518 5.60931 7.35722 5.75882 7.33812 5.92099L7.33345 5.99899V8.66566C7.33364 8.83558 7.3987 8.99901 7.51535 9.12257C7.63199 9.24613 7.79142 9.32048 7.96105 9.33044C8.13067 9.3404 8.2977 9.28521 8.428 9.17615C8.55831 9.06709 8.64205 8.91239 8.66212 8.74366L8.66678 8.66566V5.99899C8.66678 5.82218 8.59654 5.65261 8.47152 5.52759C8.3465 5.40256 8.17693 5.33232 8.00012 5.33232Z",
    fill: "#EDCA31"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1251_7142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoShow);
export default __webpack_public_path__ + "static/media/no-show.1706600d51f9b39e8f62d2d584484b2a.svg";
export { ForwardRef as ReactComponent };